import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {routerShape, withRouter} from 'react-router';
import {cn} from 'spa/css';

import {withConfig, withI18n} from 'spa/Components/Context';

import SalesforceChatButton2025 from 'spa/Components/SalesforceChatButton2025';
import ContextualMenu from 'spa/Components/ContextualMenu';
import DocumentTitle from 'spa/Components/DocumentTitle';
import DocumentMeta from 'spa/Components/DocumentMeta';

import BookingHeader from './BookingHeader/BookingHeader';

export const BOOKING_LAYOUT_THEMES = {
  dark: 'dark',
  light: 'light',
};

@withRouter
@inject(({
  store,
  store: {
    screen,
    session,
  },
}) => ({
  screen,
  session,
  store,
  tracker: store.tracker,
}))
@observer
@withConfig
@withI18n
class BookingLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    description: PropTypes.string,
    disableRedirect: PropTypes.bool,
    router: routerShape.isRequired,
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }).isRequired,
    title: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(Object.values(BOOKING_LAYOUT_THEMES)),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
  };

  static defaultProps = {
    theme: BOOKING_LAYOUT_THEMES.light,
    trackingCategory: 'Booking',
  }

  constructor(props, context) {
    super(props);

    const {config, i18n} = context;

    this.salesforceChatEnabled = config.getValue('locale.salesforce-chat-enabled', i18n.umRegion);
  }

  render() {
    const {
      children,
      description,
      disableRedirect,
      theme,
      title,
    } = this.props;
    const {
      salesforceChatEnabled,
    } = this;

    return (
      <div className="v-container full-height">
        <DocumentTitle title={title} />
        <DocumentMeta
          description={description}
          title={title}
          meta={{name: {robots: 'noindex'}}}
        />
        <ContextualMenu />
        <BookingHeader />
        <div className={cn('v-content v-content--expand', theme === BOOKING_LAYOUT_THEMES.dark && 'dark')}>
          {salesforceChatEnabled && <SalesforceChatButton2025 />}
          {children}
        </div>
      </div>
    );
  }
}

export default BookingLayout;



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/Components/BookingLayout.jsx